import React, { createContext, useContext, useState } from 'react';

// Estado compartido para que la nieve (Nieve, en App) se prenda solo cuando el
// mouse pasa por la animación de invierno que está al lado del logo (LogoInvierno,
// en NavBar). Están en ramas distintas del árbol, por eso va por contexto.
const NieveContext = createContext({ activa: false, setActiva: () => {} });

export const NieveProvider = ({ children }) => {
  const [activa, setActiva] = useState(false);
  return (
    <NieveContext.Provider value={{ activa, setActiva }}>
      {children}
    </NieveContext.Provider>
  );
};

export const useNieve = () => useContext(NieveContext);

export default NieveContext;
